import { Component, OnInit } from '@angular/core';
import { AuthService } from '../../../core/services/auth.service';
import { FormValidationService } from '../../../core/services/form-validation.service';
import { Router } from '@angular/router';
import {
  UntypedFormControl,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { ToastService } from '../../../core/services/toast.service';
import { ApiError } from '../../../core/models/common/api-error';

@Component({
  selector: 'app-forgotten-password-page',
  template: `
    <app-auth-template title="Mot de passe oublié">
      <app-text-input
        [control]="form.get('email')"
        name="email"
        label="<i class='fal fa-lg fa-paper-plane mr-1.5'></i> Adresse e-mail"
      ></app-text-input>
      <app-button data-cy="submit" (click)="submit()" [loading]="sendingData"
        >Envoyer</app-button
      >
    </app-auth-template>
  `,
  standalone: false,
})
export class ForgottenPasswordPageComponent implements OnInit {
  form: UntypedFormGroup;
  sendingData: boolean;
  constructor(
    private authService: AuthService,
    private formValidationService: FormValidationService,
    private router: Router,
    private toastService: ToastService,
  ) {}

  ngOnInit() {
    this.form = new UntypedFormGroup({
      email: new UntypedFormControl('', [
        Validators.required,
        Validators.email,
      ]),
    });
  }

  async submit() {
    if (this.formValidationService.validate(this.form)) {
      try {
        this.sendingData = true;
        await this.authService.forgottenPassword(this.form.value.email);
        this.toastService.success(
          "Un e-mail a été envoyé à l'adresse indiquée avec les instructions pour réinitialiser votre mot de passe.",
        );
        this.router.navigate(['/']);
      } catch (exception) {
        this.toastService.error((exception as ApiError).message);
      }
      this.sendingData = false;
    }
  }
}
